import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const FreeCall = () => {
  useEffect(() => {
    // Load Calendly widget script
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-blue-900 to-gray-900 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-8">
          <Link to="/" className="inline-block text-blue-400 hover:text-blue-300 font-semibold mb-6">
            ← Back to Home
          </Link>
          <h1 className="text-4xl md:text-5xl font-black text-white mb-4">Book Your Free 15-Minute Discovery Call</h1>
          <p className="text-xl text-gray-300">
            Let's discuss how we can help you build your 7-figure home care agency
          </p>
        </div>

        {/* Calendly Embed */}
        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden">
          <div className="bg-gradient-to-r from-blue-600 to-green-600 p-4 text-center">
            <h2 className="text-2xl font-bold text-white">Choose Your Appointment Time</h2>
          </div>
          <div 
            className="calendly-inline-widget" 
            data-url="https://calendly.com/admin-abilityhealthsolutions/30min"
            style={{ minWidth: '320px', height: '700px' }}
          ></div>
        </div>

        {/* Footer */}
        <div className="text-center mt-8">
          <p className="text-gray-400 text-sm">
            No cost. No commitment. No sales pitch.
          </p>
        </div>
      </div>
    </div>
  );
};

export default FreeCall;
